import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UploadImages from "../components/Upload";
import UploadDataset from "../components/UploadDataset";
import { createOrUpdateProject } from "../utils/crudFunctions";
import { getUserRole, getUserName } from "../utils/auth";

// ProjectNameForm component
const ProjectNameForm = ({ projectInput, setProjectInput, onSubmit }) => (
  <div className="bg-white shadow rounded-lg p-6">
    <h2 className="text-lg font-semibold text-gray-800 mb-2">
      Enter Project Name
    </h2>
    <input
      type="text"
      value={projectInput}
      onChange={(e) => setProjectInput(e.target.value)}
      placeholder="e.g., defect-line-01"
      className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
    />
    <button
      onClick={onSubmit}
      className="mt-4 w-full bg-blue-500 text-white font-semibold py-2 rounded-lg hover:bg-blue-600 transition-colors"
    >
      Continue to Upload
    </button>
  </div>
);

// UploadTypeSelector component
const UploadTypeSelector = ({ uploadType, setUploadType }) => (
  <div className="flex justify-center mb-6">
    <div className="inline-flex rounded-md shadow-sm" role="group">
      <button
        type="button"
        onClick={() => setUploadType("images")}
        className={`px-4 py-2 text-sm font-medium rounded-l-lg ${
          uploadType === "images"
            ? "bg-blue-500 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        Upload Images
      </button>
      <button
        type="button"
        onClick={() => setUploadType("dataset")}
        className={`px-4 py-2 text-sm font-medium rounded-r-lg ${
          uploadType === "dataset"
            ? "bg-blue-500 text-white"
            : "bg-white text-gray-700 hover:bg-gray-100"
        }`}
      >
        Upload Dataset
      </button>
    </div>
  </div>
);

function AddProject({ setProjectName }) {
  const [projectInput, setProjectInput] = useState("");
  const [nameConfirmed, setNameConfirmed] = useState(false);
  const [uploadType, setUploadType] = useState("images");
  const [userName, setUserName] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const role = getUserRole();
    let user = getUserName();
    if (role === "admin") {
      user = role;
    }
    setUserName(user);
  }, []);

  const handleNameAdd = async () => {
    const finalProjectName = projectInput.trim();
    if (!finalProjectName) {
      alert("Project name is required");
      return;
    }

    try {
      await createOrUpdateProject(finalProjectName);
      setProjectName(finalProjectName);
      setNameConfirmed(true);
      alert(`Project ${finalProjectName} created successfully`);
    } catch (error) {
      alert(error.response?.data?.error || "Something Went Wrong");
      console.error(error);
    }
  };

  return (
    <div className="h-[calc(100vh-4rem)] bg-gray-50">
      <div className="pt-14 max-w-md mx-auto">
        {!nameConfirmed ? (
          <ProjectNameForm
            projectInput={projectInput}
            setProjectInput={setProjectInput}
            onSubmit={handleNameAdd}
          />
        ) : (
          <>
            <p className="text-center text-gray-600 mb-4">
              Project:{" "}
              <span className="font-medium text-gray-800">{projectInput}</span>
            </p>

            <UploadTypeSelector 
              uploadType={uploadType} 
              setUploadType={setUploadType} 
            />

            {uploadType === "images" ? (
              <UploadImages 
                userName={userName} 
                projectInput={projectInput} 
              />
            ) : (
              <UploadDataset 
                userName={userName} 
                projectInput={projectInput} 
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default AddProject;